import { flow } from 'lodash';
import { NAME } from './dialogs.constant';

import { selectState as selectStateLogin } from '../login.selector';

const selectStateKey = (state) => state[NAME];

export const selectState = flow(selectStateLogin, selectStateKey);
